import React from 'react';
import Proptypes from 'prop-types';
import Plot from "react-plotly.js";
import { getFileName } from '../../helpers/Saxs/SaxsGeneralHelper';

const parse = require('csv-parse/lib/es5/sync.js');

class FramePlotter extends React.Component {
    render() {

        if (this.props.data) {

            let curveList = [];

            this.props.data.forEach(element => {
                let dataWithoutFirstLine = element.csvData.trim().split('\n').slice(1).join('\n');

                // parse csv data for a frame
                let x = [];
                let y = [];
                parse(dataWithoutFirstLine, {
                    cast: function (value, context) {
                        if (context.column === 0) { x.push(value); };
                        if (context.column === 1) { y.push(value); };
                    }
                })

                curveList.push({
                    x: x,
                    y: y,
                    type: 'scatter',
                    mode: 'lines+points',
                    name: getFileName(element.filePath, true),
                    showlegend: true,
                    //marker: { color: 'red' },
                })
            });

            return <Plot
                data={curveList}
                layout={{ width: '100%', title: 'A Fancy Plot' }} />
        } else {
            return null;
        }

    }

}

export default FramePlotter;

FramePlotter.proptypes = {
    /** csv data list */
    data: Proptypes.array
}



// WEBPACK FOOTER //
// ./src/components/saxs/FramePlotter.js